import type { PlayerListItem } from '../types'
import { PlayerStatsContent } from './PlayerStatsContent'
import styles from './PlayerStatsAccordion.module.css'

// ── Props ──────────────────────────────────────────────────────────────────────

type PlayerStatsAccordionProps = {
  player:       PlayerListItem
  isInSquad:    boolean
  isWindowOpen: boolean
  onAdd:        (player: PlayerListItem) => void
  onRemove:     (playerId: string) => void
  onClose:      () => void
}

// ── Component ──────────────────────────────────────────────────────────────────

export function PlayerStatsAccordion({
  player,
  isWindowOpen: _isWindowOpen,
  onAdd:        _onAdd,
  onRemove:     _onRemove,
  onClose,
}: PlayerStatsAccordionProps) {
  return (
    <div className={styles.accordionContent}>
      <PlayerStatsContent player={player} isMobile={false} />

      <button
        className={styles.closeLink}
        onClick={onClose}
        aria-label="Recolher detalhes do jogador"
      >
        <span aria-hidden="true">▲</span>
        Recolher
      </button>
    </div>
  )
}
